import { Action } from '@ngrx/store';
import { File } from '@app/models';

export enum MeActionTypes {
  SelectRole = '[Me] Select role',
  SelectCountry = '[Me] Select country',
  ResetRole = '[Me] Reset role',
  SetMe = '[Me] Set',
  UpdateAvatar = '[Me] Update avatar'
}

export class SelectRole implements Action {
  readonly type = MeActionTypes.SelectRole;
  constructor(
    public role:
      | 'planner'
      | 'designer'
      | 'regional-buyer'
      | 'country-buyer'
      | 'country-planner'
  ) {}
}

export class SelectCountry implements Action {
  readonly type = MeActionTypes.SelectCountry;
  constructor(public id: number) {}
}

export class ResetRole implements Action {
  readonly type = MeActionTypes.ResetRole;
  constructor() {}
}

export class SetMe implements Action {
  readonly type = MeActionTypes.SetMe;
  constructor(public user: any) {}
}

export class UpdateAvatar implements Action {
  readonly type = MeActionTypes.UpdateAvatar;
  constructor(public file: File) {}
}

export type MeActionsUnion =
  | SelectRole
  | SelectCountry
  | ResetRole
  | SetMe
  | UpdateAvatar;
